import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'faire_direct-faire_direct_auto_extend_banner-click';
/**
 * Tracks when the View details button on the auto-extend banner is clicked. (PRD: https:&#x2F;&#x2F;www.notion.so&#x2F;faire&#x2F;Auto-extend-FD-Credit-for-3-Days-XP-890e63dd95dc4db2a89d7cf7d9e3a931.)
 */
export function trackFaireDirectFaireDirectAutoExtendBannerClick(retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken },
    });
}
